/**
 * A boot load whose payload is wrong rather than late: a body that fails validation. Retrying fetches
 * the same body, so the retry helper rethrows it at once and the boot boundary reports it. A request
 * that failed or timed out stays a plain `Error` and is retried, and so is a body that does not parse
 * (`res.json()` throws a `SyntaxError`): a download cut off on the way can arrive whole next time.
 * Until 2026-09-26 this doc said an unparseable body was not retried (review finding 66).
 */
export class BootDataError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "BootDataError";
  }
}
